import { render } from "./LanguageSwitcher.vue?vue&type=template&id=3cf15646&scoped=true&ts=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=3cf15646&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf15646"]])

export default __exports__